// extracted by mini-css-extract-plugin
module.exports = {"label":"NewLabel_label__azDvj"};